/**
 * Статус загружаемых данных.
 */
export enum LoadState {
    /**
     * Данные не загружены и до этого не было попыток загрузки данных.
     */
    NOT_LOADED,

    /**
     * Данные загружаются.
     */
    LOADING,

    /**
     * Данные были успешно загружены.
     */
    LOADED,

    /**
     * Произошла ошибка при загрузке данных.
     */
    HAS_ERROR,
}
